import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng';

@Injectable({ providedIn: 'root' })
export class BBWTMessageService {
  public msgs: Message[] = [];

  constructor(private messageService: MessageService) {}
  //private defaultLife = 5; //seconds

  getTestString(): string {
    return 'Test string';
  }

  ShowSuccess(summary, message) {
    this.messageService.clear();
    this.messageService.add({ severity: 'success', summary: summary, detail: message });
  }

  ShowError(summary, message, lifeInSeconds?: number, key?: string) {
    this.messageService.clear();
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: message,
      key: key ?? undefined,
    });

    //alexP: commented, cause setTimeout doesn't seem to work well. the message is often hidden spontaneously
    //independend from what is set in setTimeout's delay

    ////lifeInSeconds == 0 is a case to make the message sticky
    //if (lifeInSeconds == null || lifeInSeconds > 0) {
    //    var $this = this;
    //    setTimeout(function () { $this.msgs = [] }, (lifeInSeconds == null ? this.defaultLife : lifeInSeconds) * 1000);
    //}
  }

  ShowWarning(summary, message) {
    this.messageService.clear();
    this.messageService.add({ severity: 'warn', summary: summary, detail: message });
  }

  ShowInfo(summary, message) {
    this.messageService.clear();
    this.messageService.add({ severity: 'info', summary: summary, detail: message });
  }
}
